import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

console.log("MTaibe Portfolio: Initializing System...");

// Clear aggressive service worker caching
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    let hasUnregistered = false;
    for (const registration of registrations) {
      registration.unregister();
      hasUnregistered = true;
    }
    
    if ('caches' in window) {
      caches.keys().then((names) => {
        let hasDeletedCache = false;
        for (const name of names) {
          caches.delete(name);
          hasDeletedCache = true;
        }
        if (hasUnregistered || hasDeletedCache) {
          console.log("Service Worker / Cache cleared. Reloading page for fresh assets...");
          window.location.reload();
        }
      });
    }
  });
}

const rootElement = document.getElementById('root');
if (rootElement) {
  try {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log("MTaibe Portfolio: Mounted successfully.");
  } catch (error) {
    console.error("MTaibe Portfolio: Critical mount error:", error);
  }
} else {
  console.error("MTaibe Portfolio: Root element '#root' not found in document.");
}